(() => {
  const note = document.querySelector('[data-wbo-size-guidance]');
  const root = note?.closest('product-info');
  if (!note || !root || note.dataset.initialized) return;
  note.dataset.initialized = 'true';
  const message = note.dataset.message;
  let pending = false;
  const update = () => {
    pending = false;
    const width = root.querySelector('#lookup-input1-numberAndDropdown_number-66353279ff4020fb3ca57250');
    const fraction = root.querySelector('#lookup-input1-numberAndDropdown_dropdown-66353279ff4020fb3ca57250');
    const inside = root.querySelector('[id="66280ada46f77b94ac1d7724-66280ada46f77b94ac1d7729"]');
    const mountHolder = inside?.closest('.optionHolder');
    if (mountHolder && mountHolder.nextElementSibling !== note) mountHolder.after(note);
    const wholeText = width?.value.trim() ?? '';
    const fractionText = fraction?.value.trim() ?? '';
    const decimal = /^(?:\d+(?:\.\d*)?|\.\d+)$/;
    const validNumbers = decimal.test(wholeText) && decimal.test(fractionText) && Number.isFinite(Number(wholeText)) && Number.isFinite(Number(fractionText));
    const show = validNumbers && Number(wholeText) + Number(fractionText) === 23 && inside?.checked === true;
    const text = show ? message : '';
    if (note.textContent !== text) note.textContent = text;
    note.classList.toggle('wbo-product__minimum', show);
  };
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  };
  root.addEventListener('input', schedule);
  root.addEventListener('change', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', schedule);
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'value'] });
  schedule();
})();
